module.exports = __webpack_public_path__ + "img/logo.9e050b98.svg";